import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { transformationBlocks } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function TransformationSection() {
  return <section className="bg-mp-black py-16 md:py-24" data-id="element-305" data-mp="2rxj3osdzjq3s">
      <Container data-id="element-306" data-mp="2nwz31eu7e4cw">
        <div className="max-w-[700px]" data-id="element-307" data-mp="2nxh9t5ehs0z2">
          <SectionTag tone="lime" data-id="element-308" data-mp="2nyijb5fv0feo">La transformación</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-309" data-mp="2j5z82f4n9wd1">
            Tus lunes no deberían empezar así.
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mt-8 max-w-[700px] rounded-2xl border border-mp-border bg-mp-dark p-6 md:p-7" data-id="element-310" data-mp="298bc5lvayita">
          <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-311" data-mp="fasv9o75vwal">
            El coste real de improvisar cada semana
          </p>
          <p className="mt-2 text-sm leading-relaxed text-mp-gray md:text-[15px]" data-id="element-312" data-mp="k3lww37c2oig">
            Preparar cada sesión manualmente te quita entre 3 y 5 horas semanales. Es el equivalente a un mes entero
            de trabajo al año quemado buscando en Google, mirando vídeos y dudando si el ejercicio encaja con el
            nivel del grupo.
          </p>
        </motion.div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-313" data-mp="13051qgb3tq97">
          {transformationBlocks.map((block, i) => <motion.div key={block.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i % 2 * 0.05
        }} className="overflow-hidden rounded-2xl border border-mp-border bg-mp-card" data-id="element-314" data-mp="p388k87ijwp5" data-mpi={i}>
              <p className="border-b border-mp-border bg-mp-dark px-5 py-3 font-heading text-xs uppercase tracking-[0.15em] text-mp-electric" data-id="element-315" data-mp="1kbtqcz3ivzfg">
                {block.label}
              </p>
              <div className="p-5" data-id="element-316" data-mp="1ai35s5aio951">
                <p className="text-xs uppercase tracking-wide text-mp-gray" data-id="element-317" data-mp="15lmhnb3bhury">Antes</p>
                <p className="mt-1.5 text-sm leading-relaxed text-mp-gray/90" data-id="element-318" data-mp="11jhr4l861e9j">{block.before}</p>

                <div className="mt-4 border-t border-mp-border pt-4" data-id="element-319" data-mp="wkelaykd340i">
                  <div className="flex items-center justify-between gap-2" data-id="element-320" data-mp="wj3h4xn07u8v">
                    <p className="text-xs uppercase tracking-wide text-mp-lime" data-id="element-321" data-mp="rm3bgnu2gtia">Con Maestro en Pista</p>
                    {block.stat && <span className="rounded-full bg-mp-lime/10 px-2.5 py-0.5 font-heading text-[11px] font-bold text-mp-lime" data-id="element-322" data-mp="mol7lbuwp4h5">
                        {block.stat}
                      </span>}
                  </div>
                  <p className="mt-1.5 text-sm leading-relaxed text-mp-white" data-id="element-323" data-mp="2pi1x75ajpa3g">{block.after}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}